import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { EDIT_SUPPLIER } from "../apollo/mutations";
import { useEffect } from "react";
import closeModal from "../common/closeModal";
import { getSelectedStoreDetails } from "../utils/helperFunctions";

const useEditSupplier = (rowData, refetch) => {
  console.log("rowData", rowData);
  const defaultValues = {
    id: rowData?.id ?? "",
    full_name: rowData?.full_name ?? "",
    phone: rowData?.phone ?? "",
    is_active: rowData?.is_active ?? true,
    image: rowData?.image ?? "",
  };

  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({ defaultValues });

  const [submit, { loading }] = useMutation(EDIT_SUPPLIER);

  useEffect(() => {
    reset(defaultValues);
  }, [rowData, reset]);

  const onEditSupplier = async (data) => {
    try {
      let payload = {
        variables: {
          input: {
            id: data?.id,
            full_name: data?.full_name,
            store_id: getSelectedStoreDetails("id"),
            phone: data?.phone,
            is_active: data?.is_active,
          },
          image: data?.image,
        },
      };

      console.log("payload", payload);
      console.log("data", data);

      let res = await submit(payload);

      console.log("Res From Create Brand", res);
      reset(defaultValues);
      closeModal("edit-units");
      refetch();
    } catch (error) {
      console.log("Mutation error:", error.message);
    }
  };

  const onCancel = () => {
    reset(defaultValues);
    closeModal("edit-units");
  };

  return {
    values: {
      control,
      errors,
      loading,
      image: watch("image"),
    },
    functions: {
      onSubmit: handleSubmit(onEditSupplier),
      onCancel,
    },
  };
};

export default useEditSupplier;
